var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgData = function SvgData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "data"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 16C1 19.9224 2.5582 23.6843 5.33181 26.4577C8.10543 29.2315 11.8673 30.7896 15.7897 30.7896C19.7122 30.7896 23.4741 29.2315 26.2475 26.4577C29.0213 23.6843 30.5794 19.9224 30.5794 16C30.5794 12.0775 29.0213 8.31564 26.2475 5.54202C23.4741 2.7684 19.7122 1.21021 15.7897 1.21021C11.8673 1.21021 8.10543 2.7684 5.33181 5.54202C2.5582 8.31564 1 12.0775 1 16Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.8457 11.0701H22.6915",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.748 7.12598L22.692 11.0699L18.748 15.0138",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.7335 20.9297H8.8877",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.8316 24.8738L8.8877 20.9297L12.8316 16.9858",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
export default SvgData;